module.exports = __webpack_public_path__ + "img/GB.0e3bb9c3.webp";